/* eslint-disable @typescript-eslint/no-explicit-any */

export const logger = {
  log(filename: string, message: string, data: any) {
    console.log(
      `Log - Filename: ${filename}`,
      `Message: ${message}`,
      `Data: ${JSON.stringify(data)}`,
    );
  },
  warn(filename: string, message: string, data: any) {
    console.warn(
      `Warn - Filename: ${filename}`,
      `Message: ${message}`,
      `Data: ${JSON.stringify(data)}`,
    );
  },
  error(filename: string, message: string, data?: any, error?: any) {
    console.error(
      `Error - Filename: ${filename}`,
      `Message: ${message}`,
      `Data: ${JSON.stringify(data)}; Error: ${error}`,
    );
  },
};
